import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthSocialLink } from '@nebular/auth';
import { AccountData } from '../../../@core/data/account.data';

@Component({
  selector: 'dpay-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterComponent {
  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = '';
  submitted = false;
  loading: boolean;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  socialLinks: NbAuthSocialLink[] = [];

  constructor(protected service: AccountData,
    protected cd: ChangeDetectorRef,
    protected router: Router) {
  }

  register(): void {
    this.submitted = true;
    this.loading = true;
    this.service
      .register(this.user)
      .pipe()
      .subscribe({
        next: (result) => {
          setTimeout(() => {
            return this.router.navigateByUrl(`account/registration-completed/${result.email}`);
          }, this.redirectDelay);
        },
        error: (failures: { error: { errorMessage: string; }[]; }) => {
          this.submitted = false;
          this.loading = false;
          this.errors = [];
          failures.error.forEach((err: { errorMessage: string; }) => {
            this.errors.push(err.errorMessage.replace("'Password'", "A senha"));
          });
          this.cd.detectChanges();
        }
      });
  }
}
